// prefer default export if available
const preferDefault = m => m && m.default || m

exports.components = {
  "component---node-modules-gatsby-plugin-offline-app-shell-js": () => import("C:\\Users\\Genome\\Development\\gatsby\\ryan-mcguirk-strata\\node_modules\\gatsby-plugin-offline\\app-shell.js" /* webpackChunkName: "component---node-modules-gatsby-plugin-offline-app-shell-js" */),
  "component---src-pages-404-js": () => import("C:\\Users\\Genome\\Development\\gatsby\\ryan-mcguirk-strata\\src\\pages\\404.js" /* webpackChunkName: "component---src-pages-404-js" */),
  "component---src-pages-index-js": () => import("C:\\Users\\Genome\\Development\\gatsby\\ryan-mcguirk-strata\\src\\pages\\index.js" /* webpackChunkName: "component---src-pages-index-js" */)
}

